// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2vJNT","savePackageButton":"ClientWallet_savePackageButton__2wdXW"};